module.exports = __webpack_public_path__ + "img/Jelly.bb664653.png";